import { c as _c } from "react/compiler-runtime";
import { ApiWave } from "@/generated/models/ApiWave";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { useDropPrivileges } from "@/hooks/useDropPriviledges";
import { useAuth } from "../auth/Auth";
import DropPlaceholder from "./DropPlaceholder";
import CreateDrop from "./CreateDrop";
export enum DropMode {
  CHAT = "CHAT",
  PARTICIPATION = "PARTICIPATION",
  BOTH = "BOTH",
}
interface PrivilegedDropCreatorProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
  readonly onDropAddedToQueue: () => void;
  readonly onAllDropsAdded?: () => void;
  readonly wave: ApiWave;
  readonly dropId: string | null;
  readonly fixedDropMode: DropMode;
}
export default function PrivilegedDropCreator(t0) {
  const $ = _c(29);
  const {
    activeDrop,
    onCancelReplyQuote,
    wave,
    dropId,
    fixedDropMode,
    onAllDropsAdded,
    onDropAddedToQueue
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const t1 = !!connectedProfile?.handle;
  const t2 = !!activeProfileProxy;
  const t3 = !wave.chat.enabled;
  const t4 = wave.participation.period?.min ?? null;
  const t5 = wave.participation.period?.max ?? null;
  const t6 = wave.participation.no_of_applications_allowed_per_participant ?? null;
  const t7 = wave.metrics.your_participation_drops_count ?? null;
  let t8;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== wave.chat.authenticated_user_eligible || $[8] !== wave.participation.authenticated_user_eligible) {
    t8 = {
      isLoggedIn: t1,
      isProxy: t2,
      canChat: wave.chat.authenticated_user_eligible,
      canDrop: wave.participation.authenticated_user_eligible,
      chatDisabled: t3,
      submissionStarts: t4,
      submissionEnds: t5,
      maxDropsCount: t6,
      identityDropsCount: t7
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = wave.chat.authenticated_user_eligible;
    $[8] = wave.participation.authenticated_user_eligible;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const {
    submissionRestriction,
    chatRestriction
  } = useDropPrivileges(t8);
  if (!!submissionRestriction && !!chatRestriction) {
    let t9;
    if ($[10] !== chatRestriction || $[11] !== submissionRestriction) {
      t9 = <DropPlaceholder type="both" chatRestriction={chatRestriction} submissionRestriction={submissionRestriction} />;
      $[10] = chatRestriction;
      $[11] = submissionRestriction;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    return t9;
  }
  if (fixedDropMode === DropMode.CHAT && !!chatRestriction) {
    let t9;
    if ($[13] !== chatRestriction) {
      t9 = <DropPlaceholder type="chat" chatRestriction={chatRestriction} />;
      $[13] = chatRestriction;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  if (fixedDropMode === DropMode.PARTICIPATION && !!submissionRestriction) {
    let t9;
    if ($[15] !== submissionRestriction) {
      t9 = <DropPlaceholder type="submission" submissionRestriction={submissionRestriction} />;
      $[15] = submissionRestriction;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    return t9;
  }
  let t9;
  if ($[17] !== chatRestriction || $[18] !== submissionRestriction) {
    t9 = {
      submissionRestriction,
      chatRestriction
    };
    $[17] = chatRestriction;
    $[18] = submissionRestriction;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== activeDrop || $[21] !== dropId || $[22] !== fixedDropMode || $[23] !== onAllDropsAdded || $[24] !== onCancelReplyQuote || $[25] !== onDropAddedToQueue || $[26] !== t9 || $[27] !== wave) {
    t10 = <CreateDrop activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onAllDropsAdded} wave={wave} dropId={dropId} fixedDropMode={fixedDropMode} privileges={t9} onDropAddedToQueue={onDropAddedToQueue} />;
    $[20] = activeDrop;
    $[21] = dropId;
    $[22] = fixedDropMode;
    $[23] = onAllDropsAdded;
    $[24] = onCancelReplyQuote;
    $[25] = onDropAddedToQueue;
    $[26] = t9;
    $[27] = wave;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}